module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#pen",
      toString: function () {
        return this.url;
      }
    }